import WithCookie from './WithCookie'

export default WithCookie